import React from 'react'

export const ResiliaIconBlue = () => {
  return (
    <svg width='79' height='20' viewBox='0 0 654 163'>
      <title>Resilia_Final_FullColor</title>
      <defs>
        <polygon
          id='path-1'
          points='0 0.741 336.172 0.741 336.172 149.94 0 149.94'
        />
        <polygon
          id='path-3'
          points='0.018 0.241 167.907 0.241 167.907 113.94 0.018 113.94'
        />
      </defs>
      <g
        id='Resilia_Final_FullColor'
        stroke='none'
        strokeWidth={1}
        fill='none'
        fillRule='evenodd'
      >
        <g id='Group-5' transform='translate(0.000000, 13.000000)'>
          <mask id='mask-2' fill='white'>
            <use xlinkHref='#path-1' />
          </mask>
          <g id='Clip-2' />
          <path
            d='M79.827,65.073 C84.01,59.713 86.103,51.671 86.103,40.949 C86.103,31.405 84.044,24.344 79.925,19.766 C75.807,15.19 68.712,12.901 58.644,12.901 C54.982,12.901 51.878,13.067 49.328,13.391 C46.778,13.719 45.111,13.881 44.327,13.881 L44.327,72.722 C45.895,72.986 49.686,73.115 55.703,73.115 L62.371,73.115 C69.824,73.115 75.641,70.436 79.827,65.073 Z M0,136.074 L15.495,134.113 L15.495,16.824 L0.785,14.078 L0.785,2.114 L29.224,2.114 C31.706,2.114 34.452,2.049 37.462,1.918 C40.468,1.789 42.757,1.657 44.327,1.525 C51.124,1.004 56.748,0.741 61.194,0.741 C74.66,0.741 85.448,2.114 93.557,4.86 C101.663,7.605 107.547,11.792 111.209,17.413 C114.868,23.036 116.701,30.424 116.701,39.576 C116.701,48.598 114.28,56.967 109.444,64.681 C104.604,72.398 97.608,77.693 88.457,80.568 C93.685,82.793 98.328,86.844 102.383,92.728 C106.434,98.612 110.749,106.261 115.328,115.676 C118.595,122.084 121.114,126.693 122.879,129.503 C124.644,132.317 126.376,133.917 128.077,134.309 L134.549,136.27 L134.549,147.842 L101.206,147.842 C99.113,147.842 96.922,145.718 94.635,141.468 C92.346,137.22 89.371,130.518 85.711,121.364 C81.396,110.644 77.67,102.274 74.532,96.258 C71.394,90.246 68.059,86.519 64.529,85.079 L44.327,85.079 L44.327,134.113 L62.371,136.074 L62.371,147.842 L0,147.842 L0,136.074 L0,136.074 Z'
            id='Fill-1'
            fill='#003F7E'
            mask='url(#mask-2)'
          />
          <path
            d='M207.314,83.118 C207.575,79.459 207.707,76.645 207.707,74.684 C207.707,57.295 201.887,48.598 190.25,48.598 C183.842,48.598 178.875,51.148 175.344,56.247 C171.813,61.346 169.852,70.304 169.46,83.118 L207.314,83.118 Z M153.475,134.799 C145.041,124.667 140.824,110.84 140.824,93.317 C140.824,81.548 143.012,71.349 147.395,62.719 C151.774,54.089 157.952,47.489 165.93,42.91 C173.904,38.335 183.122,36.045 193.584,36.045 C206.658,36.045 216.729,39.477 223.79,46.342 C230.851,53.207 234.51,62.983 234.773,75.665 C234.773,84.294 234.249,90.703 233.204,94.885 L169.46,94.885 C169.981,106.786 172.794,116.038 177.894,122.639 C182.993,129.243 190.25,132.543 199.665,132.543 C204.764,132.543 210.026,131.695 215.454,129.994 C220.878,128.296 225.163,126.267 228.301,123.914 L233.204,134.702 C229.674,138.496 223.952,141.992 216.042,145.195 C208.129,148.397 200.122,150 192.016,150 C174.755,150 161.909,144.934 153.475,134.799 L153.475,134.799 Z'
            id='Fill-3'
            fill='#003F7E'
            mask='url(#mask-2)'
          />
          <path
            d='M272.233,131.759 C273.278,133.329 275.666,134.799 279.392,136.172 C283.119,137.545 286.875,138.232 290.67,138.232 C296.814,138.232 301.423,136.957 304.497,134.407 C307.568,131.857 309.106,128.493 309.106,124.306 C309.106,119.991 307.209,116.495 303.418,113.813 C299.625,111.134 293.22,107.831 284.197,103.908 L278.706,101.554 C269.683,97.763 262.947,93.188 258.503,87.825 C254.057,82.464 251.835,75.536 251.835,67.035 C251.835,61.151 253.6,55.888 257.13,51.246 C260.661,46.606 265.629,42.977 272.037,40.36 C278.442,37.746 285.831,36.437 294.2,36.437 C300.345,36.437 305.606,36.83 309.989,37.614 C314.368,38.399 318.977,39.447 323.817,40.753 C326.43,41.669 328.393,42.193 329.702,42.322 L329.702,68.015 L314.206,68.015 L309.695,53.109 C308.91,51.803 307.145,50.627 304.399,49.579 C301.653,48.534 298.515,48.009 294.985,48.009 C289.622,48.009 285.34,49.156 282.138,51.442 C278.932,53.731 277.333,56.903 277.333,60.955 C277.333,64.617 278.442,67.657 280.667,70.075 C282.889,72.496 285.307,74.359 287.924,75.665 C290.538,76.973 295.377,79.13 302.438,82.137 C309.499,85.146 315.35,88.021 319.993,90.767 C324.631,93.512 328.491,97.077 331.565,101.457 C334.635,105.838 336.172,111.165 336.172,117.441 C336.172,127.12 332.379,134.964 324.797,140.977 C317.213,146.994 306.293,150 292.042,150 C285.374,150 279.392,149.412 274.096,148.235 C268.801,147.058 262.687,145.489 255.757,143.527 L251.442,142.155 L251.442,116.264 L267.722,116.264 L272.233,131.759'
            id='Fill-4'
            fill='#003F7E'
            mask='url(#mask-2)'
          />
        </g>
        <path
          d='M364.417,29.824 C361.67,27.078 360.297,23.547 360.297,19.232 C360.297,14.265 361.866,10.146 365.004,6.876 C368.143,3.609 372.327,1.972 377.557,1.972 C382.786,1.972 386.776,3.379 389.522,6.189 C392.268,9.002 393.641,12.5 393.641,16.683 C393.641,21.914 392.071,26.097 388.934,29.235 C385.795,32.374 381.413,33.943 375.792,33.943 L375.596,33.943 C370.889,33.943 367.163,32.57 364.417,29.824 Z M365.202,70.424 L351.276,66.698 L351.276,53.556 L387.168,49.241 L387.561,49.241 L393.051,53.164 L393.051,147.505 L406.194,149.074 L406.194,160.842 L351.471,160.842 L351.471,149.074 L365.202,147.309 L365.202,70.424 L365.202,70.424 Z'
          id='Fill-6'
          fill='#003F7E'
        />
        <polyline
          id='Fill-7'
          fill='#003F7E'
          points='431.688 17.467 417.174 14.918 417.174 4.326 453.459 0.011 453.852 0.011 459.147 3.738 459.147 147.505 473.465 149.074 473.465 160.842 417.959 160.842 417.959 149.074 431.688 147.309 431.688 17.467'
        />
        <g id='Group-11' transform='translate(486.000000, 49.000000)'>
          <mask id='mask-4' fill='white'>
            <use xlinkHref='#path-3' />
          </mask>
          <g id='Clip-9' />
          <polyline
            id='Fill-8'
            fill='#003F7E'
            mask='url(#mask-4)'
            points='13.944 21.424 0.018 17.698 0.018 4.556 35.911 0.241 36.303 0.241 41.793 4.164 41.793 98.505 54.936 100.074 54.936 111.842 0.213 111.842 0.213 100.074 13.944 98.309 13.944 21.424'
          />
          <path
            d='M122.012,95.269 C125.542,93.635 128.612,91.64 131.229,89.287 L131.229,57.121 C119.461,57.121 110.667,59.116 104.85,63.102 C99.03,67.092 96.122,72.223 96.122,78.5 C96.122,84.776 97.592,89.55 100.534,92.817 C103.477,96.087 107.497,97.72 112.596,97.72 C115.342,97.72 118.481,96.906 122.012,95.269 Z M84.844,54.375 C96.807,48.362 112.268,45.288 131.229,45.156 L131.229,40.645 C131.229,35.286 130.672,31.102 129.563,28.092 C128.45,25.086 126.424,22.831 123.483,21.326 C120.54,19.824 116.256,19.07 110.635,19.07 C104.227,19.07 98.475,19.888 93.375,21.522 C88.276,23.159 82.981,25.283 77.489,27.896 L71.409,15.343 C73.37,13.646 76.67,11.617 81.313,9.263 C85.954,6.91 91.479,4.85 97.887,3.086 C104.292,1.32 110.895,0.437 117.696,0.437 C127.764,0.437 135.643,1.746 141.331,4.36 C147.018,6.977 151.104,11.161 153.588,16.913 C156.071,22.669 157.315,30.381 157.315,40.056 L157.315,100.074 L167.907,100.074 L167.907,111.058 C165.29,111.713 161.563,112.363 156.727,113.019 C151.889,113.671 147.637,114 143.979,114 C139.532,114 136.555,113.344 135.055,112.039 C133.549,110.733 132.799,108.051 132.799,103.997 L132.799,98.702 C129.268,102.624 124.69,106.155 119.069,109.292 C113.446,112.431 107.106,114 100.043,114 C94.028,114 88.502,112.725 83.471,110.175 C78.436,107.626 74.415,103.899 71.409,98.996 C68.399,94.092 66.897,88.177 66.897,81.245 C66.897,69.348 72.879,60.39 84.844,54.375 L84.844,54.375 Z'
            id='Fill-10'
            fill='#003F7E'
            mask='url(#mask-4)'
          />
        </g>
        <polyline
          id='Fill-12'
          fill='#3ED865'
          points='529.117 4.058 523.88 42.023 512.026 32.809 521.264 12.644 505.51 27.756 493.62 18.503 529.117 4.058'
        />
      </g>
    </svg>
  )
}

export const Facebook = () => (
  <svg
    width='19'
    height='19'
    viewBox='0 0 19 19'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M16.175 0.75H2.42499C1.3703 0.75 0.549988 1.60938 0.549988 2.625V16.375C0.549988 17.4297 1.3703 18.25 2.42499 18.25H7.77655V12.3125H5.31561V9.5H7.77655V7.39062C7.77655 4.96875 9.22186 3.60156 11.4094 3.60156C12.5031 3.60156 13.5969 3.79688 13.5969 3.79688V6.17969H12.3859C11.175 6.17969 10.7844 6.92188 10.7844 7.70312V9.5H13.4797L13.05 12.3125H10.7844V18.25H16.175C17.1906 18.25 18.05 17.4297 18.05 16.375V2.625C18.05 1.60938 17.1906 0.75 16.175 0.75Z' />
  </svg>
)

export const LinkedIn = () => (
  <svg
    width='22'
    height='22'
    viewBox='0 0 22 22'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M20 0.5H1.95312C1.15625 0.5 0.5 1.20312 0.5 2.04688V20C0.5 20.8438 1.15625 21.5 1.95312 21.5H20C20.7969 21.5 21.5 20.8438 21.5 20V2.04688C21.5 1.20312 20.7969 0.5 20 0.5ZM6.82812 18.5H3.73438V8.51562H6.82812V18.5ZM5.28125 7.10938C4.25 7.10938 3.45312 6.3125 3.45312 5.32812C3.45312 4.34375 4.25 3.5 5.28125 3.5C6.26562 3.5 7.0625 4.34375 7.0625 5.32812C7.0625 6.3125 6.26562 7.10938 5.28125 7.10938ZM18.5 18.5H15.3594V13.625C15.3594 12.5 15.3594 11 13.7656 11C12.125 11 11.8906 12.2656 11.8906 13.5781V18.5H8.79688V8.51562H11.75V9.875H11.7969C12.2188 9.07812 13.25 8.23438 14.75 8.23438C17.8906 8.23438 18.5 10.3438 18.5 13.0156V18.5Z' />
  </svg>
)

export const Email = () => (
  <svg
    width='21'
    height='16'
    viewBox='0 0 21 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M18.1 0H2.09999C0.999991 0 0.109991 0.9 0.109991 2L0.0999908 14C0.0999908 15.1 0.999991 16 2.09999 16H18.1C19.2 16 20.1 15.1 20.1 14V2C20.1 0.9 19.2 0 18.1 0ZM18.1 4L10.1 9L2.09999 4V2L10.1 7L18.1 2V4Z' />
  </svg>
)

export const Twitter = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 24 24'
    fill='white'
    height='24'
    width='24'
  >
    <path d='M23.44 4.83c-.8.37-1.5.38-2.22.02.93-.56.98-.96 1.32-2.02-.88.52-1.86.9-2.9 1.1-.82-.88-2-1.43-3.3-1.43-2.5 0-4.55 2.04-4.55 4.54 0 .36.03.7.1 1.04-3.77-.2-7.12-2-9.36-4.75-.4.67-.6 1.45-.6 2.3 0 1.56.8 2.95 2 3.77-.74-.03-1.44-.23-2.05-.57v.06c0 2.2 1.56 4.03 3.64 4.44-.67.2-1.37.2-2.06.08.58 1.8 2.26 3.12 4.25 3.16C5.78 18.1 3.37 18.74 1 18.46c2 1.3 4.4 2.04 6.97 2.04 8.35 0 12.92-6.92 12.92-12.93 0-.2 0-.4-.02-.6.9-.63 1.96-1.22 2.56-2.14z' />
  </svg>
)
